import {RootStoreState} from '../../stores/RootStoreState';
import {IProductOptionSelectionItem} from '@wix/wixstores-client-core/dist/src/types/product';

export const getOptionSelectionItems = (state: RootStoreState): IProductOptionSelectionItem[] =>
  state.optionItems.reduce((acc, option) => {
    const selected =
      (option.selections.find((s) => s.id === state.selectionInput[option.id]) as IProductOptionSelectionItem) || null;
    return [...acc, selected];
  }, []);
